import React from "react";

import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";

export default function EndpointHealthAboutView() {
  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          About
        </Heading>
        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          What it measures
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "How reliably your backend endpoints respond to requests from your app — tracking 2xx successes against 3xx, 4xx, and 5xx responses, with server errors penalized most heavily."
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          Why it matters
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "A perfectly stable app on a flaky API is still a broken product. Most user-visible issues that aren't crashes are endpoint failures — failed logins, missing data, infinite loaders. Endpoints health surfaces a failure mode that crash dashboards miss entirely."
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          How to use it
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "Open the Data tab to find your lowest-scoring endpoint — the worst performer is usually weighted heavily, so fixing one critical endpoint often moves the score more than fixing several minor ones."
          }
        </Paragraph>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
